import React from 'react';
import CustomerQueryList from '../../../id/common/customer/CustomerQueryList';
import OrdersByCustomerDetail from './tabs/OrdersByCustomerDetail';
import { FORM_LAYOUTS, GRID_KEYS, SCREEN_NAME } from './constants';

// OM Query Orders By Customer (legacy OMD0010). The customer search panel +
// listing is the shared CustomerQueryList; this file supplies the OM identity
// (title, grid and layout keys) and the OM detail screen.
const QueryOrdersByCustomerList = () => (
  <CustomerQueryList
    title={SCREEN_NAME}
    gridKey={GRID_KEYS.CustomerList}
    layoutId={FORM_LAYOUTS.Search.id}
    layoutName={FORM_LAYOUTS.Search.name}
    renderDetail={(rowId, onBack) => <OrdersByCustomerDetail id={rowId} onBack={onBack} />}
  />
);

export default QueryOrdersByCustomerList;
